import BaseApiService from './BaseApiService.js';

class HomeworkService extends BaseApiService {
  /**
   * Fetch all homework. Since StudentTestController has a debug endpoint
   * that can fetch all homework for an org, we can use that.
   */
  async getHomework(params = {}) {
    const query = new URLSearchParams(params).toString();
    const endpoint = query ? `/api/student/debug/homework?${query}` : '/api/student/debug/homework';
    return this.makeRequest(endpoint);
  }

  /**
   * Create a new homework assignment
   */
  async createHomework(homeworkData) {
    return this.makeRequest('/api/teacher/homework', {
      method: 'POST',
      body: JSON.stringify(homeworkData)
    });
  }

  /**
   * Delete a homework assignment
   */
  async deleteHomework(homeworkId) {
    return this.makeRequest(`/api/teacher/homework/${homeworkId}`, {
      method: 'DELETE'
    });
  }

  /**
   * Mark homework assignment completed
   */
  async markHomeworkCompleted(homeworkId) {
    return this.makeRequest(`/api/teacher/homework/${homeworkId}/complete`, {
      method: 'PUT'
    });
  }

  /**
   * Get submissions for a homework assignment
   */
  /**
   * Get parent complaints for homework doubts
   */
  async getComplaints(params = {}) {
    const query = new URLSearchParams(params).toString();
    const endpoint = query ? `/api/homework-doubts/admin/complaints?${query}` : '/api/homework-doubts/admin/complaints';
    return this.makeRequest(endpoint);
  }

  /**
   * Resolve a parent complaint
   */
  async resolveComplaint(complaintId, payload) {
    return this.makeRequest(`/api/homework-doubts/admin/complaints/${complaintId}/resolve`, {
      method: 'PUT',
      body: JSON.stringify(payload)
    });
  }
}

const homeworkServiceInstance = new HomeworkService();
export default homeworkServiceInstance;
